/**
 * NotFoundPage — 404 sahifasi
 */

import { Link } from 'react-router';

export function NotFoundPage(): React.ReactElement {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <p className="text-9xl font-bold text-primary">404</p>
      <h1 className="mt-4 text-2xl font-bold">Sahifa topilmadi</h1>
      <p className="mt-2 text-muted-foreground">
        Siz qidirayotgan sahifa mavjud emas yoki ko&apos;chirilgan
      </p>
      <Link
        to="/"
        className="mt-6 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
      >
        Bosh sahifaga qaytish
      </Link>
    </div>
  );
}
